module.exports = __webpack_public_path__ + "static/media/is.84e403fd.svg";